<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">UNPAID BILLS BY STREAMS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Unpaid Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Card -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card bg-danger text-white">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-8">
                        <h5 class="text-white mb-1">Total Outstanding Amount</h5>
                        <h2 class="text-white mb-0">{{ formatPrice(summary.total || 0) }}</h2>
                      </div>
                      <div class="col-4 text-end">
                        <div class="badge bg-light text-danger fs-6 px-3 py-2">
                          {{ numberFormat(summary.count || 0) }} Unpaid Bills
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">All Unpaid Bills</h4>
                      <div>
                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Create New Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Primary Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3">
                      <!-- Revenue Stream Filter -->
                      <div class="col-md-6">
                        <label class="form-label mb-1">Revenue Stream:</label>
                        <select @change="handleRevenueStreamChange($event)" class="form-select">
                          <option value="">All Revenue Streams</option>
                          <option v-for="(stream, index) in availableStreams" :key="index"
                                  :value="stream.incomeTypePrefix">
                            {{ stream.name }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-6">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search bills..."
                                 @input="debounceSearch">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Location and Date Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-end">
                      <!-- Location Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select class="form-select" v-model="subCounty" @change="handleSubCountyChange">
                          <option value="">All Sub Counties</option>
                          <option v-for="item in subCounties" :key="item.subCountyID" :value="item">
                            {{ item.subCountyName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select class="form-select" v-model="ward" @change="handleWardChange">
                          <option value="">All Wards</option>
                          <option v-for="item in wards" :key="item.wardID" :value="item">
                            {{ item.wardName }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Zone:</label>
                        <select class="form-select" v-model="zone" @change="handleZoneChange">
                          <option value="">All Zones</option>
                          <option v-for="item in zones" :key="item.zone" :value="item.zone">
                            {{ item.zone }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">Created By:</label>
                        <select class="form-select" v-model="selectedUser" @change="getBillsPaginate()">
                          <option value="">All Users</option>
                          <option v-for="item in users" :key="item.idNo" :value="item.idNo">
                            {{ item.names }}
                          </option>
                        </select>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">From:</label>
                        <input v-model="dateFrom" class="form-control" type="date" @change="handleDateChange">
                      </div>

                      <div class="col-md-2">
                        <label class="form-label mb-1">To:</label>
                        <input v-model="dateTo" class="form-control" type="date" @change="handleDateChange">
                      </div>
                    </div>

                    <!-- Export Buttons -->
                    <div class="mt-3 d-none">
                      <button v-if="getRight('DOWNLOAD REPORTS')"
                              @click="exportToCSV()"
                              type="button"
                              class="btn btn-success me-2"
                              :disabled="exporting || billDetails.length === 0">
                        <i class="bx bxs-file-export font-size-16"></i>
                        <span class="ms-1">{{ exportButtonText }}</span>
                      </button>

                      <button v-if="getRight('DOWNLOAD REPORTS')"
                              @click="exportAllData()"
                              type="button"
                              class="btn btn-warning"
                              :disabled="exportingAll || summary.count === 0">
                        <i class="bx bx-cloud-download font-size-16"></i>
                        <span class="ms-1">{{ exportAllButtonText }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap" style="min-width: 250px;">Description</th>
                          <th class="text-nowrap">Sub County</th>
                          <th class="text-nowrap">Ward</th>
                          <th class="text-nowrap">Zone</th>
                          <th class="text-nowrap">Created By</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap">Customer</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billDetails" :key="item.id || index">
                          <td class="text-nowrap">{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
                          <td class="text-nowrap">
                            <span class="fw-semibold text-danger">{{ item.billNo || 'N/A' }}</span>
                          </td>
                          <td style="min-width: 250px;">
                            <div>
                              <strong>{{ item.description || 'N/A' }}</strong>
                              <small class="text-muted d-block">{{ item.incomeTypeDescription || '' }}</small>
                              <small class="text-muted d-block">{{ item.feeDescription || '' }}</small>
                              <small class="text-primary d-block">{{ maskPhoneNumber(item.customers) || '' }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.subCountyName || 'N/A' }}</td>
                          <td class="text-nowrap">{{ item.wardName || '' }}</td>
                          <td class="text-nowrap">{{ item.zone || '' }}</td>
                          <td class="text-nowrap">{{ item.names || item.createdBy || '' }}</td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.detailAmount || 0) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold text-success">{{ formatPrice(item.receiptAmount || 0) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold text-danger">{{ formatPrice(item.billBalance || 0) }}</span>
                          </td>
                          <td>
                            <span v-if="item.status === 'PAID'" class="badge bg-success">PAID</span>
                            <span v-else class="badge bg-danger">UNPAID</span>
                          </td>
                          <td class="text-nowrap">{{ formatDate(item.dateCreated) }}</td>
                          <td class="text-nowrap">{{ item.customerName || '' }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="viewBillDetails(item)"
                                      class="btn btn-primary btn-sm me-2"
                                      data-target="#billDetail"
                                      data-toggle="modal">
                                View
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li>
                                    <a class="dropdown-item" href="javascript: void(0);" @click.prevent="printBill(item)">
                                      <i class="mdi mdi-printer me-2"></i>Print Bill
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="javascript: void(0);" @click.prevent="emailReminder(item)">
                                      <i class="mdi mdi-email me-2"></i>Email Reminder
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="javascript: void(0);" @click.prevent="smsReminder(item)">
                                      <i class="mdi mdi-chat me-2"></i>SMS Reminder
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="7" class="text-end">{{ summary.count || 0 }} Unpaid Bills</th>
                          <th class="text-end">{{ formatPrice(totalDetailAmount) }}</th>
                          <th class="text-end">{{ formatPrice(totalReceiptAmount) }}</th>
                          <th class="text-end">{{ formatPrice(totalBillBalance) }}</th>
                          <th colspan="4"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-danger mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Data</h4>
                        <p>We are fetching the unpaid bills for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="billDetails.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Unpaid Bills Found</h4>
                        <p>{{ emptyStateMessage }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white" v-if="billDetails.length > 0">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize" @change="handlePageSizeChange">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                        <span class="ms-3 text-muted">
                          Showing {{ paginationStart }} to {{ paginationEnd }} of {{ summary.count }} entries
                        </span>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in visiblePages" :key="'page-' + page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div aria-hidden="true" aria-labelledby="myLargeModalLabel" class="modal fade receipting-modal"
             id="billDetail" role="dialog" tabindex="-1">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Bill Details - {{ billNo }}</h5>
                <button aria-label="Close" class="btn-close" data-dismiss="modal" type="button"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-6">
                    <address>
                      <strong class="text-capitalize">Bill Prepared for:</strong><br>
                      {{ billDetail.description }}<br>
                      <br>
                      Created on {{ formatDate(billDetail.dateCreated) }}
                    </address>
                  </div>
                </div>
                <div class="col-12">
                  <div class="py-2 mt-3">
                    <h3 class="font-size-15 fw-bold">Bill No: {{ billNo }}</h3>
                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-nowrap">
                      <thead class="bg-light">
                      <tr>
                        <th style="width: 70px;">No.</th>
                        <th>Customer</th>
                        <th>Description</th>
                        <th class="text-end">Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in billInfo" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.customer }}</td>
                        <td>{{ item.feeDescription }}</td>
                        <td class="text-end">{{ formatPrice(item.billTotal) }}</td>
                      </tr>
                      </tbody>
                      <tfoot class="bg-light">
                      <tr>
                        <td colspan="3" class="text-end">
                          <strong>Total</strong>
                        </td>
                        <td class="text-end">
                          <h5 class="m-0 fw-bold">{{ formatPrice(billDetail.detailAmount || 0) }}</h5>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button @click="printBill()" class="btn btn-primary waves-effect waves-light" type="button">
                  <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Bill
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Alert Toast -->
        <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
              'bg-success text-white': alert.success,
              'bg-danger text-white': alert.failed,
              'bg-info text-white': alert.info
            }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import moment from "moment";

export default {
  name: "UnPaidBillsStreams",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      exporting: false,
      exportingAll: false,
      searchTimeout: null,

      // Pagination
      currentPage: 1,
      totalPages: 1,
      pageSize: 25,

      // Filters
      search: '',
      dateFrom: '',
      dateTo: '',
      selectedIncomeTypePrefix: '', // Changed from tradeCategory/subCategory

      // Location filters
      subCounty: '',
      ward: '',
      zone: '',
      selectedUser: '',

      // Data
      billDetails: [],
      billInfo: [],
      billDetail: {},
      billNo: '',

      // Dropdown data
      subCounties: [],
      wards: [],
      zones: [],
      users: [],
      availableStreams: [], // New: Streams from getAvailableStreams API

      // Summary
      summary: { count: 0, total: 0 },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',
      emptyStateMessage: 'No unpaid bills found matching your criteria.'
    }
  },
  computed: {
    totalReceiptAmount() {
      return this.billDetails.reduce((sum, item) =>
          sum + parseFloat(item.receiptAmount || 0), 0
      );
    },

    totalBillBalance() {
      return this.billDetails.reduce((sum, item) =>
          sum + parseFloat(item.billBalance || 0), 0
      );
    },

    totalDetailAmount() {
      return this.billDetails.reduce((sum, item) =>
          sum + parseFloat(item.detailAmount || 0), 0
      );
    },

    visiblePages() {
      return this.pagination(this.currentPage, this.totalPages, 5);
    },

    paginationStart() {
      if (this.billDetails.length === 0) return 0;
      return ((this.currentPage - 1) * this.pageSize) + 1;
    },

    paginationEnd() {
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.summary.count);
    },

    exportButtonText() {
      return this.exporting ? 'Exporting...' : 'Export Current Page (CSV)';
    },

    exportAllButtonText() {
      return this.exportingAll ? 'Fetching All Data...' : `Export All (${this.numberFormat(this.summary.count)} bills)`;
    }
  },
  mounted() {
    // Set default date range
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    // Load initial data
    this.loadInitialData();
  },
  methods: {
    getRight,

    // Initialize all data
    async loadInitialData() {
      await Promise.all([
        this.getAvailableStreams(), // Changed from getTradeCategory
        this.getSubCounties(),
        this.menuAccess()
      ]);

      // Check for saved search
      if (sessionStorage.getItem("keyword")) {
        this.search = sessionStorage.getItem("keyword");
      }

      await this.getBillsPaginate();
    },

    // New method: Get Available Streams
    async getAvailableStreams() {
      try {
        const data = new FormData();
        data.append("function", "getAvailableStreams");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.availableStreams = res.data.data.streams || [];
        } else {
          console.error('Failed to load available streams:', res.data.message);
          this.showAlert('failed', 'Failed to load revenue streams');
        }
      } catch (e) {
        console.error('Error loading available streams:', e);
        this.showAlert('failed', 'Error loading revenue streams');
      }
    },

    // New method: Handle Revenue Stream Change
    handleRevenueStreamChange(event) {
      this.selectedIncomeTypePrefix = event.target.value;
      this.currentPage = 1;
      this.getBillsPaginate();
    },

    // Main data loading method
    async getBillsPaginate() {
      this.loading = true;
      this.billDetails = [];

      try {
        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", this.search);

        // Add incomeTypePrefix filter if selected
        if (this.selectedIncomeTypePrefix) {
          data.append("incomeTypePrefix", this.selectedIncomeTypePrefix);
        }

        if (this.subCounty) {
          data.append("subCountyID", this.subCounty.subCountyID);
        }

        if (this.ward) {
          data.append("wardID", this.ward.wardID);
        }

        if (this.zone) {
          data.append("zone", this.zone);
        }

        if (this.selectedUser) {
          data.append("idNo", this.selectedUser);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.billDetails = response.data.data.billDetails || [];
          this.summary = response.data.data.summary || { count: 0, total: 0 };
          this.totalPages = Math.ceil(this.summary.count / this.pageSize);
          this.updateEmptyStateMessage();
        } else {
          this.showAlert('failed', response.data.message || 'Failed to load bills');
        }
      } catch (error) {
        console.error('Error loading bills:', error);
        this.showAlert('failed', 'An error occurred while loading bills');
      } finally {
        this.loading = false;
      }
    },

    // Export current page data to CSV
    exportToCSV() {
      if (this.billDetails.length === 0) {
        this.showAlert('info', 'No data to export');
        return;
      }

      this.exporting = true;

      try {
        const csvContent = this.generateCSVContent(this.billDetails);
        this.downloadCSV(csvContent, this.generateFileName('current_page'));
        this.showAlert('success', `Successfully exported ${this.billDetails.length} records to CSV`);
      } catch (error) {
        console.error('Export error:', error);
        this.showAlert('failed', 'Failed to export data');
      } finally {
        this.exporting = false;
      }
    },

    // Export all data
    async exportAllData() {
      if (this.summary.count === 0) {
        this.showAlert('info', 'No data to export');
        return;
      }

      this.exportingAll = true;

      try {
        const allData = await this.fetchAllData();

        if (allData.length === 0) {
          this.showAlert('info', 'No data to export');
          return;
        }

        const csvContent = this.generateCSVContent(allData);
        this.downloadCSV(csvContent, this.generateFileName('all_unpaid_bills'));
        this.showAlert('success', `Successfully exported ${allData.length} unpaid bills to CSV`);
      } catch (error) {
        console.error('Export error:', error);
        this.showAlert('failed', 'Failed to export all data');
      } finally {
        this.exportingAll = false;
      }
    },

    // Fetch all data from API
    async fetchAllData() {
      const allData = [];
      const totalPages = Math.ceil(this.summary.count / 1000);

      for (let page = 1; page <= totalPages; page++) {
        const data = new FormData();
        data.append("function", "getBillsPaginate");
        data.append("page", page);
        data.append("rows_per_page", 1000);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);

        if (this.search) data.append("keyword", this.search);
        if (this.selectedIncomeTypePrefix) data.append("incomeTypePrefix", this.selectedIncomeTypePrefix);
        if (this.subCounty) data.append("subCountyID", this.subCounty.subCountyID);
        if (this.ward) data.append("wardID", this.ward.wardID);
        if (this.zone) data.append("zone", this.zone);
        if (this.selectedUser) data.append("idNo", this.selectedUser);

        try {
          const response = await execute(data, biller);
          if (response.data.success) {
            allData.push(...(response.data.data.billDetails || []));
          }
        } catch (error) {
          console.error(`Error fetching page ${page}:`, error);
        }
      }

      return allData;
    },

    // Generate CSV content
    generateCSVContent(data) {
      // Define headers
      const headers = [
        'No',
        'Bill No',
        'Description',
        'Income Type',
        'Fee Description',
        'Customer Details',
        'Customer Name',
        'Sub County',
        'Ward',
        'Zone',
        'Created By',
        'Billed Amount',
        'Amount Paid',
        'Outstanding Balance',
        'Status',
        'Date Created',
        'Days Outstanding'
      ];

      // Create CSV rows
      const rows = data.map((item, index) => {
        return [
          index + 1,
          this.escapeCSV(item.billNo || ''),
          this.escapeCSV(item.description || ''),
          this.escapeCSV(item.incomeTypeDescription || ''),
          this.escapeCSV(item.feeDescription || ''),
          this.escapeCSV(this.maskPhoneNumber(item.customers) || ''),
          this.escapeCSV(item.customerName || ''),
          this.escapeCSV(item.subCountyName || ''),
          this.escapeCSV(item.wardName || ''),
          this.escapeCSV(item.zone || ''),
          this.escapeCSV(item.names || item.createdBy || ''),
          this.formatNumber(item.detailAmount || 0),
          this.formatNumber(item.receiptAmount || 0),
          this.formatNumber(item.billBalance || 0),
          item.status || 'UNPAID',
          this.formatDateForExport(item.dateCreated),
          this.calculateDaysOutstanding(item.dateCreated)
        ];
      });

      // Add summary row
      rows.push([]);
      rows.push([
        'TOTALS',
        '',
        '',
        '',
        '',
        `${data.length} Bills`,
        '',
        '',
        '',
        '',
        '',
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.detailAmount || 0), 0)),
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.receiptAmount || 0), 0)),
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.billBalance || 0), 0)),
        '',
        '',
        ''
      ]);

      // Add metadata
      const selectedStreamName = this.getSelectedStreamName();
      const metadata = [
        ['UNPAID BILLS REPORT BY STREAMS'],
        ['Generated on:', moment().format('DD/MM/YYYY HH:mm:ss')],
        ['Date Range:', `${this.dateFrom} to ${this.dateTo}`],
        ['Filters Applied:'],
        ['Revenue Stream:', selectedStreamName || 'All'],
        ['Sub County:', this.subCounty?.subCountyName || 'All'],
        ['Ward:', this.ward?.wardName || 'All'],
        ['Zone:', this.zone || 'All'],
        ['Created By:', this.getUserName(this.selectedUser) || 'All'],
        ['Search Keyword:', this.search || 'None'],
        [],
        []
      ];

      // Combine metadata, headers, and rows
      const allRows = [...metadata, headers, ...rows];

      // Convert to CSV string
      return allRows.map(row => row.join(',')).join('\n');
    },

    // Get selected stream name for export
    getSelectedStreamName() {
      if (!this.selectedIncomeTypePrefix) return '';
      const stream = this.availableStreams.find(s => s.incomeTypePrefix === this.selectedIncomeTypePrefix);
      return stream ? stream.name : this.selectedIncomeTypePrefix;
    },

    // Calculate days outstanding
    calculateDaysOutstanding(dateCreated) {
      if (!dateCreated) return 0;
      const created = moment(dateCreated);
      const today = moment();
      return today.diff(created, 'days');
    },

    // Mask phone number
    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    // Utility function to escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';

      const stringValue = String(value);

      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    },

    // Format number for export
    formatNumber(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },

    // Format date for export
    formatDateForExport(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
    },

    // Generate filename
    generateFileName(type) {
      const timestamp = moment().format('YYYYMMDD_HHmmss');
      const dateRange = `${this.dateFrom}_to_${this.dateTo}`;
      return `unpaid_bills_streams_${type}_${dateRange}_${timestamp}.csv`;
    },

    // Download CSV file
    downloadCSV(content, filename) {
      const blob = new Blob(['\ufeff' + content], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    // Get user name helper
    getUserName(idNo) {
      const user = this.users.find(u => u.idNo === idNo);
      return user ? user.names : idNo;
    },

    // Debounced search
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.getBillsPaginate();
      }, 500);
    },

    // Filter handlers
    handleSubCountyChange() {
      this.getWards();
      this.currentPage = 1;
      this.getBillsPaginate();
    },

    handleWardChange() {
      if (this.ward) {
        this.getZones(this.ward.wardID, this.ward.wardName);
      }
      this.currentPage = 1;
      this.getBillsPaginate();
    },

    handleZoneChange() {
      if (this.zone) {
        this.getUsers(this.zone);
      }
      this.currentPage = 1;
      this.getBillsPaginate();
    },

    handleDateChange() {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1;
        this.getBillsPaginate();
      }
    },

    handlePageSizeChange() {
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.summary.count / this.pageSize);
      this.getBillsPaginate();
    },

    // Load dropdown data
    async getSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties || [];
        }
      } catch (e) {
        console.error('Error loading sub-counties:', e);
      }
    },

    async getWards() {
      this.wards = [];
      this.ward = '';

      if (!this.subCounty?.subCountyID) return;

      try {
        const data = new FormData();
        data.append("function", "getWards");
        data.append("subCountyID", this.subCounty.subCountyID);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.wards = res.data.data.wards || [];
        }
      } catch (e) {
        console.error('Error loading wards:', e);
      }
    },

    async getZones(wardID, wardName) {
      this.zones = [];

      if (!wardID) return;

      try {
        const data = new FormData();
        data.append("function", "getZones");
        data.append("wardID", wardID);

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.zones = res.data.data.zones || [];
        }
      } catch (e) {
        console.error('Error loading zones:', e);
      }
    },

    async getUsers(zone) {
      this.users = [];

      try {
        const data = new FormData();
        data.append("function", "getUsers");
        if (zone) {
          data.append("search", zone);
        }

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.users = res.data.data.users || [];
        }
      } catch (e) {
        console.error('Error loading users:', e);
      }
    },

    // View bill details
    viewBillDetails(item) {
      this.billDetail = {...item};
      this.billNo = item.billNo;

      if (item.billNo) {
        this.getBill(item.billNo);
      }
    },

    async getBill(billNo) {
      try {
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo || [];
          Object.assign(this.billDetail, res.data.data.billDetails || {});
        }
      } catch (e) {
        console.error('Error loading bill details:', e);
      }
    },

    // Actions
    printBill(item) {
      const bill = item || this.billDetail;

      localStorage['params'] = JSON.stringify({
        billNo: bill.billNo
      });

      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    emailReminder(item) {
      console.log('Email reminder for', item);
      this.showAlert('info', 'Email reminder functionality coming soon');
    },

    smsReminder(item) {
      console.log('SMS reminder for', item);
      this.showAlert('info', 'SMS reminder functionality coming soon');
    },

    // Utility methods
    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD MMM YYYY');
    },

    updateEmptyStateMessage() {
      let message = 'No unpaid bills found';

      if (this.search) {
        message += ` matching "${this.search}"`;
      }
      if (this.dateFrom && this.dateTo) {
        message += ` between ${this.formatDate(this.dateFrom)} and ${this.formatDate(this.dateTo)}`;
      }

      this.emptyStateMessage = message + '.';
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Unpaid Bills Streams");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    gotTo(route) {
      this.$router.push(route);
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = Math.min(start + maxVisibleButtons - 1, totalPages);
      }

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - maxVisibleButtons + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
        pages.unshift(1);
      }

      if (end < totalPages) {
        pages.push("...");
        pages.push(totalPages);
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBillsPaginate();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBillsPaginate();
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
        this.getBillsPaginate();
      }
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.toast-container {
  z-index: 9999;
}

.text-success {
  color: #198754 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.bg-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

/* Export button styles */
.btn-success {
  background-color: #198754;
  border-color: #198754;
}

.btn-warning {
  background-color: #ffc107;
  border-color: #ffc107;
  color: #000;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>